export default __webpack_public_path__ + "static/media/IMG_8041.b5d7aab7.webp";